import React from 'react';

// Local function to render message with variables
function renderMessageWithVars(message, variables) {
  return message.replace(/\{([A-Z_]+)\}/g, (_, key) => variables[key] || `{${key}}`);
}

// Simple, generic iPhone-like SVG frame
const IPhone14Frame = ({ children }) => (
  <svg width="240" height="480" viewBox="0 0 240 480" style={{ display: 'block' }}>
    {/* Device body */}
    <rect x="8" y="8" width="224" height="464" rx="36" fill="#222" />
    {/* Screen */}
    <rect x="20" y="40" width="200" height="400" rx="24" fill="#fff" />
    {/* Notch */}
    <rect x="90" y="20" width="60" height="12" rx="6" fill="#333" />
    {/* Content */}
    <foreignObject x="20" y="40" width="200" height="400">
      <div style={{ width: '100%', height: '100%', display: 'flex', alignItems: 'flex-end', justifyContent: 'center', padding: 16 }}>
        {children}
      </div>
    </foreignObject>
  </svg>
);

function IPhonePreview({ message, variables, showFrame = true, style }) {
  const hasMessage = message && message.trim().length > 0;
  const rendered = hasMessage ? (
    <div style={{
      background: '#f3f4f6',
      borderRadius: 20,
      padding: 12,
      fontSize: 16.5,
      color: '#222',
      minHeight: 120,
      maxWidth: 260,
      wordBreak: 'break-word',
      boxShadow: '0 2px 8px rgba(0,0,0,0.04)'
    }}>
      {renderMessageWithVars(message, variables)}
    </div>
  ) : null;
  return showFrame ? <div style={style}><IPhone14Frame>{rendered}</IPhone14Frame></div> : rendered;
}

export default IPhonePreview;